<template>
  <slide-y-up-transition :duration="500">
    <header v-if="show" class="header desktop-none">
      <div class="header__right-box" @click="showSidebar">
        <mdicon name="menu" size="24" />
      </div>
      <div class="header__title">
        {{ $route.meta.label }}
        <span v-if="mobileHeaderTitleCount" class="color-complementary-100">
          |
        </span>
        <span v-if="mobileHeaderTitleCount" class="header__title-count">
          {{ mobileHeaderTitleCount }}
        </span>
      </div>
    </header>
  </slide-y-up-transition>
</template>

<script>
import { onMounted, ref } from "vue";
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["mobileHeaderTitleCount"]),
  },
  methods: {
    ...mapActions(["setAction"]),

    showSidebar() {
      this.setAction({
        key: "visibleSidebarMobile",
        value: true,
      });
    },
  },
  setup() {
    const show = ref(false);
    onMounted(() => (show.value = true));

    // return data for use in DOM
    return { show };
  },
};
</script>
